import styled from 'styled-components';

// Helper para obtener color de borde segun status
const getBorderColor = (status) => {
    switch (status) {
        case 'sold':
            return 'rgba(128, 128, 128, 0.5)';
        case 'reserved':
            return 'rgba(255, 107, 107, 0.4)';
        default:
            return 'rgba(255, 255, 255, 0.2)';
    }
};

const getHoverBorderColor = (status) => {
    switch (status) {
        case 'sold':
            return 'rgba(128, 128, 128, 0.6)';
        case 'reserved':
            return 'rgba(255, 107, 107, 0.5)';
        default:
            return 'rgba(255, 255, 255, 0.3)';
    }
};

export const CardContainer = styled.div`
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid ${props => getBorderColor(props.$status)};
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    height: 100%;
    opacity: ${props => props.$status !== 'available' ? '0.85' : '1'};

    &:hover {
        transform: ${props => props.$status === 'available' ? 'translateY(-10px)' : 'none'};
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
        border-color: ${props => getHoverBorderColor(props.$status)};
    }
`;

export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    height: 220px;
    overflow: hidden;
    cursor: pointer;

    &:hover img {
        transform: scale(1.05);
    }
`;

export const ProductImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
`;

export const GalleryIndicator = styled.span`
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 0.4rem 0.8rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 500;
    backdrop-filter: blur(5px);
`;

export const StatusOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${props => props.$variant === 'sold'
        ? 'rgba(0, 0, 0, 0.7)'
        : 'rgba(0, 0, 0, 0.5)'};
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(${props => props.$variant === 'sold' ? '3px' : '2px'});
`;

export const StatusBadge = styled.span`
    background: ${props => props.$variant === 'sold'
        ? 'linear-gradient(135deg, #666, #444)'
        : 'linear-gradient(135deg, #ff6b6b, #ee5a5a)'};
    color: white;
    padding: 0.8rem 1.5rem;
    border-radius: 25px;
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    box-shadow: ${props => props.$variant === 'sold'
        ? '0 4px 15px rgba(0, 0, 0, 0.4)'
        : '0 4px 15px rgba(255, 107, 107, 0.4)'};
    transform: rotate(-5deg);
`;

export const ProductInfo = styled.div`
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const ProductName = styled.h3`
    font-size: 1.3rem;
    margin: 0 0 0.5rem 0;
    font-weight: 700;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1.3;
`;

export const ProductPrice = styled.span`
    font-size: 1.4rem;
    font-weight: 700;
    color: #4ecdc4;
    margin-bottom: 0.8rem;
`;

export const ProductDescription = styled.p`
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.5;
    margin: 0 0 1rem 0;
    flex-grow: 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

// Helper para obtener gradiente del boton segun status
const getButtonBackground = (status) => {
    switch (status) {
        case 'sold':
            return 'linear-gradient(135deg, #555, #333)';
        case 'reserved':
            return 'linear-gradient(135deg, #888, #666)';
        default:
            return 'linear-gradient(135deg, #ff6b8b, #6b5bff)';
    }
};

export const ReserveButton = styled.button`
    background: ${props => getButtonBackground(props.$status)};
    color: white;
    padding: 0.9rem 1.5rem;
    border: none;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    cursor: ${props => props.$status === 'available' ? 'pointer' : 'not-allowed'};
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    width: 100%;
    margin-top: auto;

    &:hover {
        transform: ${props => props.$status === 'available' ? 'translateY(-2px)' : 'none'};
        box-shadow: ${props => props.$status === 'available'
            ? '0 10px 25px rgba(107, 91, 255, 0.4)'
            : 'none'};
    }

    &:disabled {
        cursor: not-allowed;
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s;
        display: ${props => props.$status === 'available' ? 'block' : 'none'};
    }

    &:hover::before {
        left: ${props => props.$status === 'available' ? '100%' : '-100%'};
    }
`;
